import FrontNewList from "./front_new_list.js";
import FrontVq from "./front_vq.js";
import RcListComponent from "./RcListComponent";
import ItemStockView from "./item_stock_viwe.js";
import BlogItem from "./blogItem.js";
export default function Main() {

  return (
    <>
      <BlogItem />
      <FrontNewList />
      <FrontVq />
      <RcListComponent action="tamiya_list" />
      <RcListComponent action="kyosho_list" />
      <ItemStockView />
    </>
  );
}
